import { render } from "./PCGestionReservas.vue?vue&type=template&id=1ff5f176&scoped=true"
import script from "./PCGestionReservas.vue?vue&type=script&lang=js"
export * from "./PCGestionReservas.vue?vue&type=script&lang=js"

import "./PCGestionReservas.vue?vue&type=style&index=0&id=1ff5f176&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ff5f176"]])

export default __exports__